module.exports = __webpack_public_path__ + "static/Shamel_and_Family-496db6a334ee2b5c4acb1baf9f430ec3.png";